var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React, { PureComponent } from "react";
import * as PropTypes from "prop-types";
import styled from "styled-components";
import { connect } from "@irati/store";
import id from "@irati/utils/id";
import authentication from "@irati/auth";
import { PerksLogo, AdminLogo, RecognitionLogo, InsightsLogo, PerkboxLogo, MedicalLogo, MobilePerksLogo, MobileRecognitionLogo, MobileInsightsLogo, MobileMedicalLogo } from "@irati/ui/src/Logos";
import adminBg from "@irati/ui/images/adminBg.svg";
import media from "@irati/ui/src/global/media";
import HeaderLink from "./HeaderLink";
var AdminBg = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  background-image: url(", ");\n  background-position: right;\n  width: 140px;\n  margin-left: -16px;\n  a:hover,\n  a:active,\n  a:focus {\n    background-color: initial;\n    box-shadow: none;\n  }\n"], ["\n  background-image: url(", ");\n  background-position: right;\n  width: 140px;\n  margin-left: -16px;\n  a:hover,\n  a:active,\n  a:focus {\n    background-color: initial;\n    box-shadow: none;\n  }\n"])), adminBg);
var StyledPerkboxLogo = styled(PerkboxLogo)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  margin: 23px 0;\n  ", "\n"], ["\n  margin: 23px 0;\n  ",
    "\n"])), media.tablet(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    margin: 13px 0;\n  "], ["\n    margin: 13px 0;\n  "]))));
var StyledAdminLogo = styled(AdminLogo)(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  margin: 23px 0 23px 15px;\n  ", "\n"], ["\n  margin: 23px 0 23px 15px;\n  ",
    "\n"])), media.tablet(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    margin: 13px 0 13px 15px;\n  "], ["\n    margin: 13px 0 13px 15px;\n  "]))));
var HeaderCurrentApp = /** @class */ (function (_super) {
    __extends(HeaderCurrentApp, _super);
    function HeaderCurrentApp() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    HeaderCurrentApp.prototype.render = function () {
        if (!authentication.isLoggedIn()) {
            return null;
        }
        var isMobile = this.props.isMobile;
        var _a = this.context, apps = _a.apps, appPath = _a.appPath;
        var idNamespace = id("current-app", this.props);
        var idHome = id("link-home", idNamespace);
        var idAdmin = id("link-admin", idNamespace);
        var idPerks = id("link-perks", idNamespace);
        var idAccount = id("link-account", idNamespace);
        var idRecognition = id("link-recognition", idNamespace);
        var idInsights = id("link-insights", idNamespace);
        var idMedical = id("link-medical", idNamespace);
        var Logo;
        switch (appPath) {
            case apps.HOME:
                return (React.createElement(HeaderLink, { id: idAccount, to: "/", app: apps.HOME },
                    React.createElement(StyledPerkboxLogo, { id: id("img", idHome) })));
            case apps.ACCOUNT:
                return (React.createElement(HeaderLink, { id: idAccount, to: "/", app: apps.HOME },
                    React.createElement(PerkboxLogo, { id: id("img", idAccount) })));
            case apps.ADMIN:
                return (React.createElement(AdminBg, null,
                    React.createElement(StyledAdminLogo, { id: id("img", idAdmin) })));
            case apps.RECOGNITION:
                Logo = isMobile ? MobileRecognitionLogo : RecognitionLogo;
                return (React.createElement(HeaderLink, { id: idPerks, to: "/", app: apps.RECOGNITION },
                    React.createElement(Logo, { id: id("img", idRecognition) })));
            case apps.INSIGHTS:
                Logo = isMobile ? MobileInsightsLogo : InsightsLogo;
                return (React.createElement(HeaderLink, { id: idNamespace, to: "/", app: apps.INSIGHTS },
                    React.createElement(Logo, { id: id("img", idInsights) })));
            case apps.MEDICAL:
                Logo = isMobile ? MobileMedicalLogo : MedicalLogo;
                return (React.createElement(HeaderLink, { id: idNamespace, to: "/", app: apps.MEDICAL },
                    React.createElement(Logo, { id: id("img", idMedical) })));
            case apps.SEARCH:
            case apps.WALLET:
            case apps.PERKS:
                Logo = isMobile ? MobilePerksLogo : PerksLogo;
                return (React.createElement(HeaderLink, { id: idPerks, to: "/", app: apps.PERKS },
                    React.createElement(Logo, { id: id("img", idPerks) })));
            default:
                return null;
        }
    };
    HeaderCurrentApp.contextTypes = {
        apps: PropTypes.object.isRequired,
        appPath: PropTypes.string.isRequired
    };
    return HeaderCurrentApp;
}(PureComponent));
var mapStateToProps = function (_a) {
    var mq = _a.mq;
    return ({
        isMobile: mq.lessThan.md
    });
};
export default connect(mapStateToProps)(HeaderCurrentApp);
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5;
